export default class CMSHelper {
  static isHalfWidthComponent(element: HTMLElement): boolean {
    return element.closest('.half-width-slot') !== null;
  }
}
